var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { role: "form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "row", staticStyle: { "margin-bottom": "10px" } },
        [
          _c("div", { staticClass: "col", staticStyle: { display: "flex" } }, [
            _c(
              "span",
              {
                staticStyle: {
                  color: "#008dbd",
                  cursor: "pointer",
                  "margin-left": "auto",
                  "margin-right": "15px"
                },
                on: {
                  click: function($event) {
                    _vm.toggleOptionals()
                  }
                }
              },
              [
                _vm.showOptionals
                  ? _c("span", { staticClass: "fa fa-minus-circle" })
                  : _c("span", { staticClass: "fa fa-plus-circle" }),
                _vm._v(
                  "\n\n        " +
                    _vm._s(_vm.$t("optional_fields")) +
                    "\n      "
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-6" },
          [
            _c("div", { staticClass: "form-group" }, [
              _c(
                "select",
                {
                  staticClass: "form-control",
                  domProps: { value: _vm.value.countryCode },
                  on: {
                    change: function(e) {
                      return _vm.onInput(e, "countryCode")
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v(_vm._s(_vm.$t("all_countries")))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.countries, function(value, key) {
                    return _c(
                      "option",
                      { key: key, domProps: { value: key } },
                      [_vm._v(_vm._s(_vm.$t("countries." + key)))]
                    )
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm.showOptionals
              ? [
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        placeholder: _vm.$t("placeholder_street"),
                        type: "text"
                      },
                      domProps: { value: _vm.value.streetAddress },
                      on: {
                        input: function(e) {
                          return _vm.onInput(e, "streetAddress")
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        placeholder: _vm.$t("placeholder_zip"),
                        type: "text"
                      },
                      domProps: { value: _vm.value.postalCode },
                      on: {
                        input: function(e) {
                          return _vm.onInput(e, "postalCode")
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        placeholder: _vm.$t("placeholder_city"),
                        type: "text"
                      },
                      domProps: { value: _vm.value.addressLocality },
                      on: {
                        input: function(e) {
                          return _vm.onInput(e, "addressLocality")
                        }
                      }
                    })
                  ])
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "input-group" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  placeholder: _vm.$t("placeholder_company"),
                  type: "text"
                },
                domProps: { value: _vm.value.licenseeName },
                on: {
                  input: function(e) {
                    return _vm.onInput(e, "licenseeName")
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "input-group-btn" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      disabled: _vm.value.licenseeName.length < 3,
                      type: "submit"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("search_button")))]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("span", { staticStyle: { cursor: "pointer" } }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("example_search")) + ":\n        "
            ),
            _c(
              "span",
              {
                staticStyle: { color: "#008dbd" },
                on: { click: _vm.submitExample }
              },
              [_vm._v(_vm._s(_vm.$t("example_company_name")))]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a720b32e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a720b32e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanySearchForm.vue
// module id = null
// module chunks = 